import React, { type ReactNode } from 'react';
import { styled as styled2 } from '@compiled/react';
import { Checkbox } from '@atlaskit/checkbox';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import type { ReferenceType } from '../../../controllers/configuration/types.tsx';

type Props = {
	referenceTypes: ReferenceType[];
	onChange: (updated: ReferenceType) => void;
};

export const ReferenceTypeToggleList = (props: Props) => {
	const { referenceTypes, onChange } = props;

	const onToggleReferenceType = (referenceTypeToUpdate: ReferenceType) => {
		const updatedReferenceType = {
			...referenceTypeToUpdate,
			checked: !referenceTypeToUpdate.checked,
		};
		onChange(updatedReferenceType);
	};

	return (
		<Box xcss={containerStyles}>
			{referenceTypes.map((rt: ReferenceType) => (
				<InputContainer key={rt.label}>
					<Checkbox
						isChecked={rt.checked}
						onChange={() => onToggleReferenceType(rt)}
						testId={`servicedesk-insight-object-graph.ui.graph-config-panel.reference-types-toggle-list.checkbox-${rt.label}`}
					/>
					<ColorCircle color={rt.color} />
					<LabelText>{rt.label}</LabelText>
				</InputContainer>
			))}
		</Box>
	);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ColorCircle = ({ color, children }: { color: any; children?: ReactNode }) => (
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
	<Box xcss={[colorCircleStyles, xcss({ backgroundColor: color })]}>{children}</Box>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LabelText = styled2.p({
	margin: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InputContainer = styled2.div({
	display: 'flex',
	alignItems: 'center',
	marginBottom: token('space.100', '8px'),
	wordWrap: 'break-word',
	overflowWrap: 'break-word',
	wordBreak: 'break-word',
});

const containerStyles = xcss({
	marginTop: 'space.200',
});

const colorCircleStyles = xcss({
	height: '28px',
	minWidth: '28px',
	borderRadius: 'border.radius.circle',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const visibleForTesting = {
	ColorCircle,
	LabelText,
};
